export const INT_NSM_NS_STATES = {
  ACTIVE: "ACTIVE",
  INACTIVE: "INACTIVE",
  INVALID: "INVALID",
  PENDING_CREATE: "PENDING_CREATE",
  PENDING_UPDATE: "PENDING_UPDATE",
  PENDING_DELETE: "PENDING_DELETE",
  PENDING_DEACTIVATE: "PENDING_DEACTIVATE",
  PENDING_ACTIVATE: "PENDING_ACTIVATE"
} as const;
